import React from 'react'
import { createContext, useContext } from 'react'
import type { AxiosRequestConfig, AxiosError } from 'axios'

export type BackendQueryOptions<V> = AxiosRequestConfig & { data?: V; authorized?: boolean }
export type BackendMutationOptions = AxiosRequestConfig
export type BackendError = AxiosError<{ error: string; message: string; statusCode: number }>

export interface BackendContextValue {
  query: <T, V = any>(path: string, options?: BackendQueryOptions<V>) => Promise<T>
  humpclubQuery: <T, V = any>(path: string, options?: BackendQueryOptions<V>) => Promise<T>
  mutation: <T, R>(path: string, options?: BackendMutationOptions) => (data: R) => Promise<T>
  humpclubMutation: <T, R>(
    path: string,
    options?: BackendMutationOptions,
  ) => (data: R) => Promise<T>
}

export const BackendContext = createContext<BackendContextValue>(undefined)

export const BackendProvider = ({ query, mutation, humpclubQuery, humpclubMutation, children }) => {
  return (
    <BackendContext.Provider value={{ query, mutation, humpclubQuery, humpclubMutation }}>
      {typeof children === 'function' ? children() : children}
    </BackendContext.Provider>
  )
}

export const useBackendContext = (): BackendContextValue => {
  const context = useContext(BackendContext)

  if (context == null) {
    throw Error('useBackendContext must be used within <BackendProvider />')
  }

  return context
}

export default useBackendContext
